// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__389gT","approved":"Status_approved__2_tON","rejected":"Status_rejected__1ZW6y","expired":"Status_expired__1gVrk","label":"Status_label__2qxFP"};